import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import withFirebaseAuth from "react-with-firebase-auth";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import firebaseConfig from "./firebaseConfig";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
// firebase.analytics();
const db = firebase.firestore();

db.enablePersistence().catch((err) => {
  if (err.code == "failed-precondition") {
    alert(
      "Oh yikes—looks like multiple tabs are open. Offline support may be weird."
    );
  } else if (err.code == "unimplemented") {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
  }
});

const firebaseAppAuth = firebaseApp.auth();
const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
};

const AppWithFirebaseAuth = withFirebaseAuth({
  providers,
  firebaseAppAuth,
})(App);

ReactDOM.render(
  <AppWithFirebaseAuth db={db} />,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
